import { compose, withProps } from 'recompose'
import upperFirst from 'lodash/upperFirst'
import isFunction from 'lodash/isFunction'
import withFetchResource from 'hocs/bases/withFetchResource'
import withUpdateResource from 'hocs/bases/withUpdateResource'
import withLoading from 'hocs/bases/withLoading'
import withStateChanged from 'hocs/bases/withStateChanged'
import CmsApis from 'apis/cmsApis'

/**
 * output props
 *    {resourceName}
 *    onChange
 *    updateResource
 *    updateResourceStatus
 *    isStateChanged
 *    setIsStateChanged
 *    onDiscardChange
 */

const withEditPage = ({
  resourceName,
  onChangeName = 'onChange',
  onSaveName = 'onSave',
  onSaveStatus = 'saveStatus',
  getInitialState,
  getInitialResource,
  getFetchAction,
  getUpdateAction,
  getOnChange,
  getOnFetchSuccess = () => () => {},
  getOnUpdateSuccess = () => () => {},
  fetchPredicate,
}) => {
  const ResourceName = upperFirst(resourceName)
  return compose(
    withStateChanged({
      getInitialState,
    }),
    withFetchResource({
      resourceName,
      getInitialResource,
      getAction: getFetchAction || (() => CmsApis[`get${ResourceName}ById`]),
      getResourceId: (props) => props.params.id,
      getSuccessData: ({ data }) => data,
      getOnSuccess: (props) => (resource) => {
        getOnFetchSuccess(props)(resource)
        return props.setTempState(resource)
      },
      fetchPredicate, // default is true => always fetch resource in componentDidMount
    }),
    withLoading({
      getIsLoading: (props) => props[`fetch${ResourceName}Status`].isRequest,
      getMessage: (props) => props[`fetch${ResourceName}Status`].message,
    }),
    withUpdateResource({
      resourceName,
      getAction: getUpdateAction || (() => CmsApis[`update${ResourceName}ById`]),
      getOnActionSuccess: ({ setIsStateChanged, setTempState, ...props }) => (data) => {
        setTempState(data)
        getOnUpdateSuccess(props)(data)
        return setIsStateChanged(false)
      },
    }),
    withProps((props) => ({
      [onChangeName]: getOnChange ? getOnChange(props) : props.setResource,
      onDiscardChange: () => {
        props.setResource(props.tempState)
      },
      [onSaveName]: (data) => props[`update${ResourceName}`](
        data && !isFunction(data) ?
          data
          :
          props[resourceName],
      ),
      [onSaveStatus]: props[`update${ResourceName}Status`],
    })),
  )
}

export default withEditPage



// WEBPACK FOOTER //
// ./src/hocs/extends/withEditPage.js